import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './index.css';
import './styles/responsive.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find #root element in index.html');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
